<script setup lang="ts">
const { t } = useI18n();
definePageMeta({
  layout: 'auth',
  middleware: 'guest',
  aliases: ['/register'],
});
useSeoMeta({
  title: t('pages.auth.register.title'),
  description: t('pages.auth.register.description'),
});
</script>

<template>
  <auth-register-form>
    <template #header>
      <nav-auth-panel>
        {{ t('pages.auth.register.title') }}
      </nav-auth-panel>
    </template>
  </auth-register-form>
</template>
